'use client';

import { useEffect, useRef } from 'react';

import type { BazaarvoiceSubmittedData } from '@libs/common-next';

import { dataLayerPush } from '@/shared/analytics';

const BAZAARVOICE_FORM_SELECTOR = '[data-bv-show="inpage_submission"]';

export function BVSubmitReviewAnalytics() {
    const isConfigured = useRef(false);

    const submissionSubmitted = ({ Id, contentType, SubmittedStep }: BazaarvoiceSubmittedData) => {
        // on mandatory review step user leaves a star rating
        if (contentType === 'review' && SubmittedStep === 'mandatory') {
            const el = document.querySelector(BAZAARVOICE_FORM_SELECTOR);
            const selectedStar = el?.shadowRoot?.querySelector('[aria-checked="true"]');
            const rating = parseInt(selectedStar?.id?.match(/bv-ips-star-rating-(\d)/)?.[1] ?? '', 10);

            dataLayerPush({
                event: 'post_review',
                product_id: Id,
                rating,
            });
        }
    };

    useEffect(() => {
        if (window.BV?.configure && !isConfigured.current) {
            window.BV.configure('global', {
                events: {
                    submissionSubmitted,
                },
            });

            isConfigured.current = true;
        }
    }, []);

    return null;
}
